export default __webpack_public_path__ + "static/media/dashboard.cafa0e3d.png";